import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { SearchBar } from "./SearchBar";
import { TransactionsTable } from "./TransactionsTable";
import { Badge } from "@/components/ui/badge";
import { useAtomValue } from "jotai";
import { SelectedFundAtom } from "@/store/FundStateAtom";
import { TransactionWithInstrumentAndAccount } from "@/types";

interface TransactionsCardProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  isLoading: boolean;
  filteredTransactions: TransactionWithInstrumentAndAccount[];
  onViewTransaction: (transaction: TransactionWithInstrumentAndAccount) => void;
  onConfirmTransaction: (
    transaction: TransactionWithInstrumentAndAccount,
    isConfirmed: boolean
  ) => void;
  onDeleteTransaction: (transaction: TransactionWithInstrumentAndAccount) => void;
}

export const TransactionsCard: React.FC<TransactionsCardProps> = ({
  searchQuery,
  setSearchQuery,
  isLoading,
  filteredTransactions,
  onViewTransaction,
  onConfirmTransaction,
  onDeleteTransaction,
}) => {
  const selectedFund = useAtomValue(SelectedFundAtom);

  return (
    <Card className="mb-6">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <div className="flex items-center gap-3">
          <CardTitle>Transaction Management </CardTitle>
          {selectedFund && (
            <Badge variant="outline" className="text-sm">
              Filtered for {selectedFund.name}
            </Badge>
          )}
        </div>
      </CardHeader>
      <CardContent>
        <TransactionsTable
          isLoading={isLoading}
          transactions={filteredTransactions}
          onViewTransaction={onViewTransaction}
          onConfirmTransaction={onConfirmTransaction}
          onDeleteTransaction={onDeleteTransaction}
        />
      </CardContent>
    </Card>
  );
};
